import type { OpenPricingModalOptions } from './const';
import { PlanSection, PricingModalOrigin } from '@wegic/price-ui';
import { getRemixInsufficientCreditsOpenOptions, getRemixUpgradeButtonOpenOptions, shouldUseRemixModal } from '@/components/RemixUpgradeModal/helper';
import { resolvePricingMultiYearPageDecision } from '@/experiments/pricingMultiYearPage';
import { getPricingModalClickId, setPricingModalOrigin } from '@/services/pay/storage';
import { usePricingModalStore } from '@/stores/pricingModal';
import { useProjectStore } from '@/stores/project';
import { useRemixUpgradeModalStore } from '@/stores/remixUpgradeModal';
import { useUserStore } from '@/stores/user';

export function openPricingModal(options: OpenPricingModalOptions) {
  const { initialSection, origin, popoupType } = options;

  const currentProject = useProjectStore.getState().currentProjectDetail;
  setPricingModalOrigin(origin, { popoupType });

  if (shouldUseRemixModal(currentProject)) {
    const userPoints = useUserStore.getState().userPoints;
    const creditPurchaseQuota = useRemixUpgradeModalStore.getState().creditPurchaseQuota;
    const openOptions = origin === PricingModalOrigin.ChatInsufficientCredits
      ? getRemixInsufficientCreditsOpenOptions()
      : getRemixUpgradeButtonOpenOptions({
          userPoints,
          totalCreditsPurchased: creditPurchaseQuota?.purchased ?? 0,
        });

    useRemixUpgradeModalStore.getState().open(openOptions);
    return;
  }

  if (origin === PricingModalOrigin.CustomDomain && initialSection === PlanSection.PLAN_LANDING) {
    const pricingClickId = getPricingModalClickId();
    const { isLogin, userInfo } = useUserStore.getState();
    const userId = userInfo?.userId;

    void resolvePricingMultiYearPageDecision().then((decision) => {
      const currentUser = useUserStore.getState();
      if (
        getPricingModalClickId() !== pricingClickId
        || currentUser.isLogin !== isLogin
        || currentUser.userInfo?.userId !== userId
      ) {
        return;
      }

      usePricingModalStore.getState().open(
        initialSection,
        decision.experience.planSelectionMode !== 'direct-checkout',
      );
    });
    return;
  }

  usePricingModalStore.getState().open(initialSection);
}
